import request from "@/utils/request";
/**
 * 获取课程合辑详情
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getAdvclassDetailApi(data) {
  return request({
    url: "product/advclass/detail",
    data: data,
    method: "post",
  });
}

export function getDirlApi(data) {
  return request({
    url: "product/advclass/get_dir",
    data: data,
    method: "post",
  });
}
